import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const fr = {
  common: {
    loading: 'Chargement…',
    save: 'Enregistrer',
    cancel: 'Annuler',
    submit: 'Soumettre',
    next: 'Suivant',
    back: 'Retour',
    yes: 'Oui',
    no: 'Non',
    copy: 'Copier',
    copied: 'Copié',
    error_generic: 'Une erreur est survenue',
    welcome_back: 'Bon retour',
    member: 'Membre',
    admin: 'Admin',
    superadmin: 'Super Admin',
    compliance: 'Conformité',
    logout: 'Déconnexion',
    logged_out: 'Déconnecté',
    fr: 'Français',
    en: 'English',
  },
  nav: {
    my_account: 'Mon compte',
    administration: 'Administration',
    dashboard: 'Tableau de bord',
    withdraw: 'Retirer',
    send: 'Envoyer',
    history: 'Historique',
    verification: 'Vérification',
    profile: 'Profil',
    overview: 'Aperçu',
    users: 'Utilisateurs',
    transactions: 'Transactions',
    withdrawals: 'Retraits',
    kyc_queue: 'File KYC',
    rates: 'Taux',
  },
  auth: {
    hero_title_login: 'Argent par-delà <em>les frontières</em>,<br/>attention par-delà <em>les continents</em>.',
    hero_desc_login: 'Envoyez et recevez des fonds en Côte d\'Ivoire en quelques minutes. Approuvé par des milliers, conçu pour la diaspora.',
    hero_title_register: 'Rejoignez <em>des milliers</em><br/>qui transfèrent leur argent<br/>de manière <em>intelligente</em>.',
    hero_desc_register: 'Créez votre compte AYAEL en moins de 2 minutes. Vérifiez votre identité et envoyez de l\'argent immédiatement.',
    hero_title_verify: 'Presque <em>terminé</em>.',
    hero_desc_verify: 'Nous avons envoyé un code à 6 chiffres à votre téléphone. Saisissez-le ci-dessous pour activer votre compte.',
    hero_title_forgot: 'Mot de passe <em>oublié</em> ?',
    hero_desc_forgot: 'Cela arrive à tout le monde. Saisissez votre numéro et nous vous enverrons un code de réinitialisation.',
    avg_transfer: 'Transfert moyen',
    countries: 'Pays',
    fatf_compliant: 'FATF Conforme',
    welcome_back: 'Bon retour',
    welcome_back_desc: 'Connectez-vous à votre compte AYAEL pour continuer.',
    create_account: 'Créer un compte',
    create_account_desc: 'Cela ne prend qu\'une minute pour commencer.',
    verify_phone: 'Vérifier votre téléphone',
    verify_phone_desc_with: 'Saisissez le code envoyé à {{phone}}',
    verify_phone_desc_without: 'Saisissez votre numéro et le code que nous avons envoyé.',
    reset_password: 'Réinitialiser le mot de passe',
    reset_password_desc: 'Nous vous enverrons un SMS avec un code pour réinitialiser votre mot de passe.',
    enter_new_password: 'Saisir le nouveau mot de passe',
    enter_new_password_desc: 'Vérifiez votre SMS pour le code de réinitialisation.',
    phone: 'Numéro de téléphone',
    phone_ci_label: 'Téléphone (Côte d\'Ivoire)',
    phone_required: 'Numéro requis',
    phone_invalid: 'Format invalide',
    phone_ci_required: 'Numéro ivoirien requis (+225 + 10 chiffres)',
    ci_only_notice: 'AYAEL opère uniquement en Côte d\'Ivoire.',
    password: 'Mot de passe',
    password_required: 'Mot de passe requis',
    password_min: '8 caractères minimum',
    password_complex: 'Doit contenir une majuscule et un chiffre',
    password_placeholder: '8+ caractères, 1 majuscule, 1 chiffre',
    new_password: 'Nouveau mot de passe',
    confirm_new_password: 'Confirmer le nouveau mot de passe',
    current_password: 'Mot de passe actuel',
    first_name: 'Prénom',
    last_name: 'Nom',
    required: 'Requis',
    language: 'Langue',
    otp_label: 'Code OTP (envoyé par SMS)',
    otp_placeholder: 'Code à 6 chiffres',
    otp_required: 'Code requis',
    otp_min: '6 chiffres',
    otp_expires: 'Le code expire dans 10 minutes.',
    verification_code: 'Code de vérification',
    reset_code: 'Code de réinitialisation',
    login_btn: 'Connexion',
    login_btn_loading: 'Connexion…',
    verify_otp_btn: 'Vérifier OTP',
    create_btn: 'Créer le compte',
    create_btn_loading: 'Création…',
    verify_continue_btn: 'Vérifier et continuer',
    verify_btn_loading: 'Vérification…',
    send_reset_btn: 'Envoyer le code',
    send_reset_loading: 'Envoi…',
    reset_btn: 'Réinitialiser',
    reset_loading: 'Réinitialisation…',
    forgot_password: 'Mot de passe oublié ?',
    no_account: 'Pas encore de compte ?',
    have_account: 'Déjà un compte ?',
    back_to_login: 'Retour à la connexion',
    didnt_receive: 'Vous ne l\'avez pas reçu ?',
    resend_code: 'Renvoyer le code',
    resending: 'Envoi…',
    welcome_toast: 'Bon retour, {{name}} !',
    login_failed: 'Échec de la connexion',
    check_phone_otp: 'Vérifiez votre téléphone pour le code',
    register_success: 'Compte créé ! Vérifiez votre téléphone.',
    register_failed: 'Échec de l\'inscription',
    verified_login: 'Téléphone vérifié ! Veuillez vous connecter.',
    verify_failed: 'Échec de la vérification',
    code_sent: 'Nouveau code envoyé !',
    code_sent_failed: 'Échec de l\'envoi',
    phone_unavailable: 'Numéro de téléphone non disponible',
    forgot_sent: 'Si votre numéro est enregistré, vous recevrez un code.',
    forgot_failed: 'Échec de la demande',
    reset_success: 'Mot de passe réinitialisé ! Veuillez vous connecter.',
    reset_failed: 'Échec de la réinitialisation',
  },
  dashboard: {
    title: 'Tableau de bord',
    subtitle: 'Votre argent, vos mouvements. Tout en un coup d\'œil.',
    kyc_required: 'Vérification d\'identité requise',
    kyc_required_desc: 'Complétez votre KYC pour débloquer l\'envoi et la réception d\'argent.',
    verify_now: 'Vérifier maintenant →',
    total_sent: 'Total envoyé',
    across_n_tx: 'Sur {{count}} transactions',
    account_status: 'Statut du compte',
    kyc_level_verified: 'KYC Niveau {{level}} vérifié',
    kyc_pending: 'KYC en attente',
    daily_limit: 'Limite journalière',
    rolling_24h: 'Sur 24h glissantes',
    risk_score: 'Score de risque',
    low_risk: 'Risque faible',
    moderate_risk: 'Modéré',
    elevated_risk: 'Élevé',
    referral_code: 'Code de parrainage',
    share_earn: 'Partagez et gagnez',
    recent_activity: 'Activité récente',
    see_all: 'Tout voir →',
    no_tx_yet: 'Pas encore de transactions.',
    no_tx_yet_desc: 'Commencez à envoyer ou recevoir pour voir l\'activité ici.',
    recent_volume: 'Volume récent',
    no_data: 'Pas de données',
    tips: 'Conseils',
    tip_speed: 'Les retraits sont généralement complétés en <strong>moins de 10 minutes</strong>.',
    tip_security: 'Nous utilisons un chiffrement bancaire et des contrôles AML conformes FATF.',
    tip_beneficiaries: 'Enregistrez vos bénéficiaires pour envoyer plus rapidement la prochaine fois.',
    withdrawal: 'Retrait',
    money_sent: 'Argent envoyé',
  },
  send: {
    title: 'Envoyer de l\'argent',
    subtitle: 'Transferts rapides vers Mobile Money en Côte d\'Ivoire.',
    kyc_required: 'KYC requis',
    kyc_required_desc: 'Complétez la vérification pour envoyer de l\'argent.',
    complete_kyc: 'Compléter le KYC →',
    amount: 'Montant',
    you_send: 'Vous envoyez (XOF)',
    currency_notice: 'Devise : Franc CFA (XOF) — Côte d\'Ivoire uniquement.',
    pay_with: 'Payer avec',
    recipient_receives_via: 'Le bénéficiaire reçoit via',
    mobile_money: 'Mobile Money',
    card: 'Carte de débit / crédit',
    bank_transfer: 'Virement bancaire',
    cash_pickup: 'Retrait en espèces',
    quote: 'Devis',
    live_preview: 'Aperçu en direct',
    amount_sent: 'Montant envoyé',
    fee: 'Frais',
    exchange_rate: 'Taux de change',
    recipient_gets: 'Le bénéficiaire reçoit',
    estimated_delivery: 'Livraison estimée : {{eta}}',
    enter_amount_quote: 'Saisissez un montant pour voir le devis en direct',
    recipient: 'Bénéficiaire',
    saved_beneficiary: 'Bénéficiaire enregistré',
    new_recipient: 'Nouveau bénéficiaire',
    no_beneficiaries: 'Vous n\'avez pas encore de bénéficiaires enregistrés. Cliquez sur « Nouveau bénéficiaire ».',
    no_phone: 'Pas de téléphone',
    phone_ci: 'Téléphone (+225…)',
    mobile_money_provider: 'Opérateur Mobile Money',
    address_optional: 'Adresse (facultatif)',
    sending: 'Envoi…',
    send_money_btn: 'Envoyer l\'argent',
    select_or_add: 'Sélectionnez ou ajoutez un bénéficiaire',
    transfer_initiated: 'Transfert initié ! Code : {{ref}}',
    transfer_failed: 'Échec du transfert',
  },
  withdraw: {
    title: 'Retirer de l\'argent',
    subtitle: 'Recevez les fonds qui vous sont envoyés via Western Union, MoneyGram ou RIA.',
    kyc_required: 'KYC requis',
    kyc_required_desc: 'Vous devez compléter la vérification d\'identité pour effectuer des retraits.',
    complete_kyc: 'Compléter le KYC →',
    step_transfer: 'Détails du transfert',
    step_documents: 'Téléverser les documents',
    step_disbursement: 'Décaissement',
    transfer_details: 'Détails du transfert',
    partner: 'Partenaire',
    select: '— Sélectionner —',
    select_partner: 'Sélectionnez un partenaire',
    mtcn: 'MTCN / Code de référence',
    mtcn_placeholder: 'Code à 10-12 chiffres',
    code_required: 'Code requis',
    expected_amount: 'Montant attendu',
    amount_required: 'Montant requis',
    currency: 'Devise',
    xof_franc: 'XOF (Franc CFA)',
    sender_name: 'Nom de l\'expéditeur (tel qu\'inscrit sur le transfert)',
    sender_name_placeholder: 'Nom complet',
    sender_required: 'Nom de l\'expéditeur requis',
    next_documents: 'Suivant : Documents',
    upload_documents: 'Téléverser les documents',
    required_compliance: 'Requis pour la vérification de conformité.',
    id_document: 'Document d\'identité (recto)',
    upload_id_drag: 'Cliquez ou faites glisser la photo de votre pièce d\'identité',
    file_types: 'JPG, PNG, PDF · max 5 Mo',
    signed_doc: 'Document signé (date + signature)',
    upload_signed: 'Téléverser l\'autorisation signée',
    signed_hint: 'Doit inclure votre signature et la date du jour',
    next_disbursement: 'Suivant : Décaissement',
    receive_funds_where: 'Où recevoir les fonds',
    receive_via: 'Recevoir via',
    prepaid_card: 'Carte prépayée',
    provider: 'Opérateur',
    bank_name: 'Nom de la banque',
    account_number: 'Numéro de compte',
    swift_iban: 'SWIFT / IBAN',
    confirm_label: 'En soumettant, vous confirmez :',
    confirm_text: 'Vous êtes le bénéficiaire légitime, les documents sont authentiques, et vous comprenez que les fonds sont libérés sous 10 minutes après vérification.',
    submitting: 'Soumission…',
    submit_withdrawal: 'Soumettre le retrait →',
    upload_required: 'Veuillez téléverser les deux documents requis',
    submitted_success: 'Retrait soumis ! Traitement en 10 minutes.',
    submission_failed: 'Échec de la soumission',
  },
  history: {
    title: 'Historique des transactions',
    subtitle: 'Tous vos transferts, recherchables et exportables.',
    all_types: 'Tous les types',
    all_statuses: 'Tous les statuts',
    completed: 'Terminé',
    pending: 'En attente',
    processing: 'En traitement',
    failed: 'Échoué',
    cancelled: 'Annulé',
    on_hold: 'En suspens',
    reference: 'Référence',
    type: 'Type',
    amount: 'Montant',
    recipient_partner: 'Bénéficiaire / Partenaire',
    status: 'Statut',
    date: 'Date',
    no_tx: 'Aucune transaction',
    page_of: 'Page {{page}} sur {{total}} · {{count}} au total',
    previous: 'Précédent',
    next: 'Suivant',
    withdrawal: 'Retrait',
    send: 'Envoi',
  },
  profile: {
    title: 'Profil',
    subtitle: 'Gérez les détails de votre compte et la sécurité.',
    email: 'E-mail',
    language: 'Langue',
    date_of_birth: 'Date de naissance',
    nationality: 'Nationalité',
    save_changes: 'Enregistrer les modifications',
    profile_updated: 'Profil mis à jour',
    update_failed: 'Échec de la mise à jour',
    security: 'Sécurité',
    change_password: 'Changer le mot de passe',
    password_changed: 'Mot de passe changé',
    change_failed: 'Échec du changement',
    passwords_no_match: 'Les mots de passe ne correspondent pas',
    your_referral_code: 'Votre code de parrainage',
    share_with_friends: 'Partagez ce code avec vos amis. Vous recevrez tous les deux des crédits au premier transfert.',
  },
  kyc: {
    title: 'Vérification d\'identité',
    subtitle: 'Requis par la réglementation pour envoyer et recevoir de l\'argent. Prend moins de 5 minutes.',
    pending_review: 'En attente · Examen par notre équipe',
    under_review: 'En cours · Identité en cours de vérification',
    approved: 'Approuvé · Vous êtes entièrement vérifié',
    rejected: 'Rejeté · {{reason}}',
    please_resubmit: 'Veuillez resoumettre',
    status_label: 'KYC {{status}}',
    verified_title: 'Votre identité est vérifiée',
    valid_until: 'Valide jusqu\'au {{date}}.',
    valid_until_unknown: 'avis ultérieur',
    section_id: '1. Détails du document d\'identité',
    section_photos: '2. Photos du document',
    document_type: 'Type de document',
    national_id: 'Carte nationale d\'identité',
    passport: 'Passeport',
    drivers_license: 'Permis de conduire',
    residence_permit: 'Titre de séjour',
    id_number: 'Numéro de pièce',
    expiry_date: 'Date d\'expiration',
    issuing_country: 'Pays émetteur',
    date_of_birth: 'Date de naissance',
    nationality: 'Nationalité',
    nationality_placeholder: 'ex. CI',
    id_front: 'Pièce recto',
    id_back: 'Pièce verso (le cas échéant)',
    selfie: 'Selfie',
    drop_or_click: 'Déposez ou cliquez pour téléverser',
    file_limit: 'JPG, PNG · max 5 Mo',
    photo_tip: '📸 Astuce : Utilisez un bon éclairage, assurez-vous que tout le texte est lisible et que le selfie correspond à la photo de la pièce.',
    uploading: 'Téléversement…',
    submit_verification: 'Soumettre pour vérification',
    id_selfie_required: 'La photo de pièce et le selfie sont requis',
    submission_received: 'Soumission reçue ! Examen sous 1-24 heures.',
    submission_failed: 'Échec de la soumission',
    countries: {
      CI: "Côte d'Ivoire", TG: 'Togo', SN: 'Sénégal', GH: 'Ghana',
      NG: 'Nigeria', BF: 'Burkina Faso', ML: 'Mali', BJ: 'Bénin', CM: 'Cameroun',
    },
  },
  brand: {
    remittance: 'Transferts d\'argent',
  },
  status: {
    pending: 'En attente', processing: 'En cours', on_hold: 'En attente',
    completed: 'Terminé', failed: 'Échoué', cancelled: 'Annulé',
    active: 'Actif', suspended: 'Suspendu', inactive: 'Inactif',
    locked: 'Verrouillé', under_review: 'En examen', approved: 'Approuvé',
    rejected: 'Rejeté',
  },
};

const en = {
  common: {
    loading: 'Loading…',
    save: 'Save',
    cancel: 'Cancel',
    submit: 'Submit',
    next: 'Next',
    back: 'Back',
    yes: 'Yes',
    no: 'No',
    copy: 'Copy',
    copied: 'Copied',
    error_generic: 'Something went wrong',
    welcome_back: 'Welcome back',
    member: 'Member',
    admin: 'Admin',
    superadmin: 'Super Admin',
    compliance: 'Compliance',
    logout: 'Logout',
    logged_out: 'Logged out',
    fr: 'Français',
    en: 'English',
  },
  nav: {
    my_account: 'My Account',
    administration: 'Administration',
    dashboard: 'Dashboard',
    withdraw: 'Withdraw',
    send: 'Send Money',
    history: 'History',
    verification: 'Verification',
    profile: 'Profile',
    overview: 'Overview',
    users: 'Users',
    transactions: 'Transactions',
    withdrawals: 'Withdrawals',
    kyc_queue: 'KYC Queue',
    rates: 'Rates',
  },
  auth: {
    hero_title_login: 'Money across <em>borders</em>,<br/>care across <em>continents</em>.',
    hero_desc_login: 'Send and receive funds across Côte d\'Ivoire in minutes. Trusted by thousands, built for the diaspora.',
    hero_title_register: 'Join <em>thousands</em><br/>moving money the<br/><em>smart way</em>.',
    hero_desc_register: 'Create your AYAEL account in under 2 minutes. Verify your identity, and start sending money home right away.',
    hero_title_verify: 'Almost <em>there</em>.',
    hero_desc_verify: 'We sent a 6-digit code to your phone. Enter it below to activate your account and continue.',
    hero_title_forgot: 'Forgot your <em>password?</em>',
    hero_desc_forgot: 'Happens to everyone. Enter your phone and we\'ll send you a reset code.',
    avg_transfer: 'Average transfer',
    countries: 'Countries',
    fatf_compliant: 'FATF Compliant',
    welcome_back: 'Welcome back',
    welcome_back_desc: 'Log in to your AYAEL account to continue.',
    create_account: 'Create account',
    create_account_desc: 'It only takes a minute to get started.',
    verify_phone: 'Verify your phone',
    verify_phone_desc_with: 'Enter the code sent to {{phone}}',
    verify_phone_desc_without: 'Enter your phone number and the code we sent.',
    reset_password: 'Reset password',
    reset_password_desc: 'We\'ll text you a code to reset your password.',
    enter_new_password: 'Enter new password',
    enter_new_password_desc: 'Check your SMS for the reset code.',
    phone: 'Phone number',
    phone_ci_label: 'Phone (Côte d\'Ivoire)',
    phone_required: 'Phone is required',
    phone_invalid: 'Invalid phone format',
    phone_ci_required: 'Ivorian number required (+225 + 10 digits)',
    ci_only_notice: 'AYAEL operates only in Côte d\'Ivoire.',
    password: 'Password',
    password_required: 'Password is required',
    password_min: 'Min 8 characters',
    password_complex: 'Requires uppercase + number',
    password_placeholder: '8+ characters, 1 uppercase, 1 number',
    new_password: 'New password',
    confirm_new_password: 'Confirm new password',
    current_password: 'Current password',
    first_name: 'First name',
    last_name: 'Last name',
    required: 'Required',
    language: 'Language',
    otp_label: 'OTP Code (sent via SMS)',
    otp_placeholder: '6-digit code',
    otp_required: 'OTP required',
    otp_min: '6 digits',
    otp_expires: 'Code expires in 10 minutes.',
    verification_code: 'Verification code',
    reset_code: 'Reset code',
    login_btn: 'Login',
    login_btn_loading: 'Logging in…',
    verify_otp_btn: 'Verify OTP',
    create_btn: 'Create account',
    create_btn_loading: 'Creating…',
    verify_continue_btn: 'Verify & Continue',
    verify_btn_loading: 'Verifying…',
    send_reset_btn: 'Send reset code',
    send_reset_loading: 'Sending…',
    reset_btn: 'Reset password',
    reset_loading: 'Resetting…',
    forgot_password: 'Forgot password?',
    no_account: 'No account yet?',
    have_account: 'Already have an account?',
    back_to_login: 'Back to login',
    didnt_receive: 'Didn\'t receive it?',
    resend_code: 'Resend code',
    resending: 'Sending…',
    welcome_toast: 'Welcome back, {{name}}!',
    login_failed: 'Login failed',
    check_phone_otp: 'Check your phone for the login code',
    register_success: 'Account created! Check your phone for the OTP.',
    register_failed: 'Registration failed',
    verified_login: 'Phone verified! Please login.',
    verify_failed: 'Verification failed',
    code_sent: 'New code sent!',
    code_sent_failed: 'Could not resend',
    phone_unavailable: 'Phone number not available',
    forgot_sent: 'If your phone is registered, you will receive a code.',
    forgot_failed: 'Request failed',
    reset_success: 'Password reset! Please login.',
    reset_failed: 'Reset failed',
  },
  dashboard: {
    title: 'Dashboard',
    subtitle: 'Your money, your moves. Everything at a glance.',
    kyc_required: 'Identity verification required',
    kyc_required_desc: 'Complete KYC to unlock sending and receiving money.',
    verify_now: 'Verify now →',
    total_sent: 'Total sent',
    across_n_tx: 'Across {{count}} transactions',
    account_status: 'Account Status',
    kyc_level_verified: 'KYC Level {{level}} verified',
    kyc_pending: 'KYC pending',
    daily_limit: 'Daily Limit',
    rolling_24h: 'Per 24h rolling window',
    risk_score: 'Risk Score',
    low_risk: 'Low risk',
    moderate_risk: 'Moderate',
    elevated_risk: 'Elevated',
    referral_code: 'Referral Code',
    share_earn: 'Share and earn',
    recent_activity: 'Recent activity',
    see_all: 'See all →',
    no_tx_yet: 'No transactions yet.',
    no_tx_yet_desc: 'Start sending or receiving money to see activity here.',
    recent_volume: 'Recent volume',
    no_data: 'No data yet',
    tips: 'Tips',
    tip_speed: 'Withdrawals are typically completed in <strong>under 10 minutes</strong>.',
    tip_security: 'We use bank-grade encryption and FATF-compliant AML controls.',
    tip_beneficiaries: 'Save beneficiaries to send to family faster next time.',
    withdrawal: 'Withdrawal',
    money_sent: 'Money sent',
  },
  send: {
    title: 'Send money',
    subtitle: 'Fast transfers to Mobile Money in Côte d\'Ivoire.',
    kyc_required: 'KYC required',
    kyc_required_desc: 'Complete verification to send money.',
    complete_kyc: 'Complete KYC →',
    amount: 'Amount',
    you_send: 'You send (XOF)',
    currency_notice: 'Currency: CFA Franc (XOF) — Côte d\'Ivoire only.',
    pay_with: 'Pay with',
    recipient_receives_via: 'Recipient receives via',
    mobile_money: 'Mobile Money',
    card: 'Debit / Credit Card',
    bank_transfer: 'Bank Transfer',
    cash_pickup: 'Cash pickup',
    quote: 'Quote',
    live_preview: 'Live preview',
    amount_sent: 'Amount sent',
    fee: 'Fee',
    exchange_rate: 'Exchange rate',
    recipient_gets: 'Recipient gets',
    estimated_delivery: 'Estimated delivery: {{eta}}',
    enter_amount_quote: 'Enter an amount to see a live quote',
    recipient: 'Recipient',
    saved_beneficiary: 'Saved beneficiary',
    new_recipient: 'New recipient',
    no_beneficiaries: 'You have no saved beneficiaries yet. Click "New recipient".',
    no_phone: 'No phone',
    phone_ci: 'Phone (+225…)',
    mobile_money_provider: 'Mobile Money operator',
    address_optional: 'Address (optional)',
    sending: 'Sending…',
    send_money_btn: 'Send money',
    select_or_add: 'Select or add a beneficiary',
    transfer_initiated: 'Transfer initiated! Code: {{ref}}',
    transfer_failed: 'Transfer failed',
  },
  withdraw: {
    title: 'Withdraw money',
    subtitle: 'Receive funds sent to you via Western Union, MoneyGram, or RIA.',
    kyc_required: 'KYC required',
    kyc_required_desc: 'You must complete identity verification to make withdrawals.',
    complete_kyc: 'Complete KYC →',
    step_transfer: 'Transfer details',
    step_documents: 'Upload documents',
    step_disbursement: 'Disbursement',
    transfer_details: 'Transfer details',
    partner: 'Remittance partner',
    select: '— Select —',
    select_partner: 'Select a partner',
    mtcn: 'MTCN / Reference code',
    mtcn_placeholder: '10-12 digit code',
    code_required: 'Code required',
    expected_amount: 'Expected amount',
    amount_required: 'Amount required',
    currency: 'Currency',
    xof_franc: 'XOF (CFA Franc)',
    sender_name: 'Sender name (as on transfer)',
    sender_name_placeholder: 'Full name',
    sender_required: 'Sender name required',
    next_documents: 'Next: Upload documents',
    upload_documents: 'Upload documents',
    required_compliance: 'Required for compliance verification.',
    id_document: 'ID document (front)',
    upload_id_drag: 'Click or drag ID photo here',
    file_types: 'JPG, PNG, PDF · max 5MB',
    signed_doc: 'Signed document (date + signature)',
    upload_signed: 'Upload signed authorization',
    signed_hint: 'Must include your signature and today\'s date',
    next_disbursement: 'Next: Disbursement',
    receive_funds_where: 'Where to receive funds',
    receive_via: 'Receive via',
    prepaid_card: 'Prepaid Card',
    provider: 'Provider',
    bank_name: 'Bank name',
    account_number: 'Account number',
    swift_iban: 'SWIFT / IBAN',
    confirm_label: 'By submitting, you confirm:',
    confirm_text: 'You are the rightful recipient, documents are authentic, and you understand funds are released within 10 minutes upon verification.',
    submitting: 'Submitting…',
    submit_withdrawal: 'Submit withdrawal →',
    upload_required: 'Please upload both required documents',
    submitted_success: 'Withdrawal submitted! Processing in 10 minutes.',
    submission_failed: 'Submission failed',
  },
  history: {
    title: 'Transaction history',
    subtitle: 'Every transfer you\'ve ever made, searchable and exportable.',
    all_types: 'All types',
    all_statuses: 'All statuses',
    completed: 'Completed',
    pending: 'Pending',
    processing: 'Processing',
    failed: 'Failed',
    cancelled: 'Cancelled',
    on_hold: 'On hold',
    reference: 'Reference',
    type: 'Type',
    amount: 'Amount',
    recipient_partner: 'Recipient / Partner',
    status: 'Status',
    date: 'Date',
    no_tx: 'No transactions yet',
    page_of: 'Page {{page}} of {{total}} · {{count}} total',
    previous: 'Previous',
    next: 'Next',
    withdrawal: 'Withdrawal',
    send: 'Send',
  },
  profile: {
    title: 'Profile',
    subtitle: 'Manage your account details and security.',
    email: 'Email',
    language: 'Language',
    date_of_birth: 'Date of birth',
    nationality: 'Nationality',
    save_changes: 'Save changes',
    profile_updated: 'Profile updated',
    update_failed: 'Update failed',
    security: 'Security',
    change_password: 'Change password',
    password_changed: 'Password changed',
    change_failed: 'Change failed',
    passwords_no_match: 'Passwords do not match',
    your_referral_code: 'Your referral code',
    share_with_friends: 'Share this code with friends. You\'ll both receive credits on first transfer.',
  },
  kyc: {
    title: 'Identity verification',
    subtitle: 'Required by regulations to send and receive money. Takes under 5 minutes.',
    pending_review: 'Pending review · Awaiting our team',
    under_review: 'Under review · Identity being verified',
    approved: 'Approved · You are fully verified',
    rejected: 'Rejected · {{reason}}',
    please_resubmit: 'Please resubmit',
    status_label: 'KYC {{status}}',
    verified_title: 'Your identity is verified',
    valid_until: 'Valid until {{date}}.',
    valid_until_unknown: 'further notice',
    section_id: '1. Identity document details',
    section_photos: '2. Document photos',
    document_type: 'Document type',
    national_id: 'National ID',
    passport: 'Passport',
    drivers_license: 'Driver\'s License',
    residence_permit: 'Residence Permit',
    id_number: 'ID number',
    expiry_date: 'Expiry date',
    issuing_country: 'Issuing country',
    date_of_birth: 'Date of birth',
    nationality: 'Nationality',
    nationality_placeholder: 'e.g. CI',
    id_front: 'ID Front',
    id_back: 'ID Back (if applicable)',
    selfie: 'Selfie',
    drop_or_click: 'Drop or click to upload',
    file_limit: 'JPG, PNG · max 5MB',
    photo_tip: '📸 Tip: Use good lighting, make sure all text is readable, and the selfie should match the ID photo.',
    uploading: 'Uploading…',
    submit_verification: 'Submit for verification',
    id_selfie_required: 'ID photo and selfie are required',
    submission_received: 'Submission received! Review in 1-24 hours.',
    submission_failed: 'Submission failed',
    countries: {
      CI: "Côte d'Ivoire", TG: 'Togo', SN: 'Senegal', GH: 'Ghana',
      NG: 'Nigeria', BF: 'Burkina Faso', ML: 'Mali', BJ: 'Benin', CM: 'Cameroon',
    },
  },
  brand: {
    remittance: 'Remittance',
  },
  status: {
    pending: 'Pending', processing: 'Processing', on_hold: 'On hold',
    completed: 'Completed', failed: 'Failed', cancelled: 'Cancelled',
    active: 'Active', suspended: 'Suspended', inactive: 'Inactive',
    locked: 'Locked', under_review: 'Under review', approved: 'Approved',
    rejected: 'Rejected',
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { fr: { translation: fr }, en: { translation: en } },
    fallbackLng: 'fr',
    supportedLngs: ['fr', 'en'],
    interpolation: { escapeValue: false },
    lng: typeof window !== 'undefined' && window.localStorage
      ? (window.localStorage.getItem('ayael_lang') || 'fr')
      : 'fr',
    detection: {
      order: ['localStorage'],
      lookupLocalStorage: 'ayael_lang',
      caches: ['localStorage'],
    },
  });

export default i18n;
